import { times } from "ramda";
import { createRoomId, createRoomLabel } from "./building-layout.types";

/**
 * Function: generateRow
 * 
 * Generates a room for a row based on the provided parameters.
 * 
 * @param {object} params - The parameters for generating the row.
 * @param {string} params.rowId - The unique identifier for the row.
 * @param {number} params.rowNumber - The row number.
 * @param {number} params.numberOfRooms - The number of rooms to generate in the row.
 * @param {number} params.width - The width of the row.
 * @param {any} params.spaceFuncOptions - The available space function options for the rooms.
 * 
 * @returns {object} - The generated row object with rooms.
 */
export const generateRow = ({
  rowId,
  rowNumber,
  numberOfRooms,
  width,
  spaceFuncOptions,
}: {
  rowId: string;
  rowNumber: number;
  numberOfRooms: number;
  width: number;
  spaceFuncOptions: any;
}) => {
  const rooms = times((number: number) => {
    const result = {
      id: createRoomId(rowNumber, number),
      label: createRoomLabel(rowNumber, number),
      number,
      width,
      spaceFunctionId: spaceFuncOptions[0].value,
      length: {
        creationType: "RANDOM" as const,
        generatorType: 2,
        value: "21",
        options: {
          min: 1,
          max: 10,
        },
      },
      isVariableLength: number === 0 ? true : false,
    };
    return result;
  }, numberOfRooms);
  const row: any = {
    numberOfRooms,
    width,
    rooms,
  };
  return row;
};
